export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#1a1f3a] via-[#2d2550] to-[#4a3b6e]">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>
      
      {/* Floating geometric shapes */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-20 w-32 h-32 rounded-full bg-white/5 animate-pulse"></div>
        <div className="absolute top-40 right-32 w-24 h-24 rounded-full bg-white/5 animate-pulse delay-100"></div>
        <div className="absolute bottom-32 left-40 w-40 h-40 rounded-full bg-white/5 animate-pulse delay-200"></div>
        <div className="absolute bottom-20 right-20 w-28 h-28 rounded-full bg-white/5 animate-pulse delay-300"></div>
      </div>

      <div className="relative z-10 text-center px-8 w-full max-w-5xl mx-auto">
        <h1 className="mb-3">
          <div className="text-7xl font-extralight text-white tracking-wide">
            iOS App Development
          </div>
          <div className="text-7xl italic text-[#d4af37] mt-3" style={{ fontFamily: 'Playfair Display, serif' }}>
            Experts
          </div>
        </h1>
        
        <p className="text-xl text-white/75 mt-12 max-w-2xl mx-auto leading-relaxed">
          Specializing in VPN and Cleaner applications for enhanced mobile security
        </p>
      </div>
    </section>
  );
}